$(function() {
    $(document).on('keyup', 'input.js-number', function(){
        var val = $(this).val();
        if(val){
            val = parseInt(val);
            if(isNaN(val)){
                val = 1;
            }
        }
        
        $(this).val(val);
    });

    
});
